
import React, { useState, useEffect, useContext, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Layout,DeleteConfirmationModal } from '../../../../components';
import AppContext from '../../../../contexts/AppContext';
import { handleApi, formatCurrency, formatTwoDecimal, formatMediumDate, capitalize,AudioSpinner,useToast } from '../../../../utils/utils';

const DeleteQuotation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { initialQuotation } = location.state || {};
  const [quotation, setQuotation] = useState(initialQuotation || {});
  console.log('initialQuotation',initialQuotation)
  const { showToast, toastMessage } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const { userData, currentColor, actionCount,setActionCount} = useContext(AppContext);
  const quotationRef = useRef(null); // Ref to the quotation content for PDF generation
  const [itemToDelete, setItemToDelete] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleAction = (action) => {
    if (action === 'download') {
      console.log('handleDownload');
    } else if (action === 'print') {
        window.print();
    } else {
      showToast(`Simulated action: ${action}`, 'success');
    }
  };
  const handleDeleteClick = (item) => {
    setItemToDelete(item);
    setIsModalOpen(true);
  };

  const handleConfirmDelete = () => {
    handleAction('delete', itemToDelete);
    console.log("Item deleted!");
    setIsModalOpen(false);
  };

  const handleCancelDelete = () => {setIsModalOpen(false);};

  const handleSubmit = async () => {
    setIsLoading(true);
    const apiEndpoint = 'sales/orders';
      try {
        const response = await handleApi(apiEndpoint, {}, userData, 'DELETE',  { id: initialQuotation.id });
        if (response.status === 200) {
          //setShowDeleteButton(false); // Hide the button on success
          setQuotation(prevQuotation => ({ ...prevQuotation, state: 'cancelled' }));
          showToast(response.data.message || 'Quotation deleted  successfully!', 'success');
        } 
          else {showToast(response.data.message || 'Error deleting  quotation !', 'error');}
      } catch (error) {
        showToast( error.message || 'Error deleting  quotation !', 'error');;}
      finally {
        setActionCount(actionCount + 1);
        setIsLoading(false);
      }
    };
    
  const TransactionLineHeader = () => {
    return (
      <div className="grid grid-cols-6 gap-2 p-2 border-b rounded-lg bg-gray-100 text-gray-800 font-semibold text-xs md:text-xs">
        <div className="col-span-2 text-left">Product Description</div>
        <div className="col-span-1 text-center">Price</div>
        <div className="col-span-1 text-center">Qty</div>
        <div className="col-span-1 text-center">Disc %</div>
        <div className="col-span-1 text-right">Total</div>
      </div>
    );
  };
  
  const subtotal = quotation?.totalPriceExclusive || 0;
  const discountAmount = quotation?.totalDiscountInclusive || 0;
  const subtotalAfterDiscount = quotation?.totalDiscountedPriceExclusive || 0;
  const taxAmount = quotation?.totalTaxAfterDiscounted || 0;
  const grandTotal = quotation?.totalPriceInclusive || 0;
  
  const formattedSubtotal = subtotal;
  const formattedDiscount = discountAmount;
  const formattedSubtotalAfterDiscount = subtotalAfterDiscount;
  const formattedTax = taxAmount;
  const formattedGrandTotal = formatCurrency(grandTotal);

  return (
     <Layout>
    <div className="min-h-screen text-white p-2 sm:p-4">
      {toastMessage.show && (
        <div className={`fixed top-4 left-1/2 transform -translate-x-1/2 px-4 py-2 rounded-lg shadow-md z-50
                        ${toastMessage.type === 'success' ? 'bg-green-500 text-white' : 'bg-red-500 text-white'}`}>
          {toastMessage.message}
        </div>
      )}

      <div className="relative flex justify-between items-center mb-4">
        <h1 className="font-extrabold text-gray-800 tracking-wide flex-grow text-center">
          DELETE QUOTATION
        </h1>
        <div className="flex gap-2">
          <button
          handleSubmit
            onClick={() => handleSubmit()}
            className="mr-8 px-2 py-1 rounded-xl font-semibold text-white bg-cyan-200 hover:bg-gray-700 transition-all duration-300 flex items-center gap-1 text-sm sm:text-base"
            title="Delete"
          >
            <svg className="h-5 w-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.013 21H7.987a2 2 0 01-1.92-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
        
            </svg>

          </button>
          
          <button
            onClick={() => navigate(-1)}
            className="p-2 rounded-full text-gray-800 bg-white hover:bg-gray-300 transition-all duration-300"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      <div className="bg-gray-600 rounded-3xl shadow-lg p-2 sm:p-4 mx-auto max-w-[80%]">
        

        {isLoading ? (
          <div className="flex flex-col items-center py-6">
            <AudioSpinner />
            <p className="mt-4 text-gray-400">Deleting Quotation. Please wait...</p>
          </div>
        ) : (
          <div className="space-y-6">
            <div className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                <div className="bg-gray-500 p-4 rounded-xl text-cyan-200">
                  <p className="font-semibold text-white text-center mb-4 uppercase">Customer Info</p>
                  <div className="space-y-1 text-xs grid grid-cols-2 gap-x-4">
                    <label className="font-medium text-cyan-200">Name</label>
                    <span className="text-white font-medium text-right">{quotation?.partners?.name || 'NA'}</span>
                    
                    <label className="font-medium text-cyan-200">Telephone</label>
                    <span className="text-white font-medium text-right">{quotation?.partners?.phone_number || 'NA'}</span>
                    
                    <label className="font-medium text-cyan-200">Contact Person</label>
                    <span className="text-white font-medium text-right">{quotation?.partners?.contact_person || 'NA'}</span>
                  </div>
                </div>

                <div className="bg-gray-500 p-4 rounded-xl text-cyan-200">
                  <p className="font-semibold text-white text-center mb-4 uppercase">Quotation Info</p>
                  <div className="space-y-1 text-xs grid grid-cols-2 gap-x-4">
                    <label className="font-medium text-cyan-200">Reference #</label>
                    <span className="text-white font-medium text-right">{quotation?.reference || 'NA'}</span>
                    
                    <label className="font-medium text-cyan-200">Quote Date</label>
                    <span className="text-white font-medium text-right">{formatMediumDate(quotation?.date) || 'NA'}</span>
                    
                    <label className="font-medium text-cyan-200">Status</label>
                    <span className={`font-semibold text-right ${quotation.state?.toLowerCase() === 'draft' ? 'rounded-md px-1 text-yellow-400 bg-yellow-900' :
                             quotation.state?.toLowerCase() === 'approved' ? ' rounded-md px-1 text-blue-400 bg-blue-900' :
                             quotation.state?.toLowerCase() === 'invoiced' ? 'rounded-md px-1 text-green-400 bg-green-900' :
                             quotation.state?.toLowerCase() === 'deleted' ? 'rounded-md px-1 text-red-400 bg-red-900' :
                             quotation.state?.toLowerCase().includes('cancel') ? 'rounded-md px-1 text-red-400 bg-red-900' : 'text-yellow-400'}`}>
                          {quotation?.state?.toUpperCase() || 'NA'}

                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-gray-500 rounded-lg">
                <TransactionLineHeader />
                <div className="px-1">
                  {quotation.transactionLines?.length > 0 ? (
                    <>
                      {quotation.transactionLines.map((line, index) => (
                        <div key={index} className="grid grid-cols-6 items-center px-3 py-1 rounded-lg hover:bg-cyan-200 transition-colors duration-200">
                          <div className="col-span-2 text-left text-xs sm:text-xs text-white">{index + 1}. {line.description || 'N/A'}</div>
                          <div className="col-span-1 text-center text-xs sm:text-xs text-white">{line.unit_price}</div>
                          <div className="col-span-1 text-center text-xs sm:text-xs text-white">{line.quantity || '0'}</div>
                          <div className="col-span-1 text-center text-xs sm:text-xs text-white">{line.discount_percentage || '0'}</div>
                          <div className="col-span-1 text-right text-xs sm:text-xs text-white">{line.lineDiscountedPriceExclusive}</div>
                        </div>
                      ))}
                    </>
                  ) : (
                    <p className="p-6 text-center text-gray-400">No transactions found.</p>
                  )}
                </div>
              </div>

              <div className="bg-gray-500 px-4 py-2 rounded-xl shadow-lg">
                <div className="font-semibold text-lg sm:text-xl text-white mb-2">Invoice Summary</div>
                <div className="space-y-1">
                  <div className="flex justify-between items-center py-1 border-b border-cyan-200">
                    <div className="text-xs text-gray-200">Subtotal:</div>
                    <div className="text-xs font-semibold text-white">{formattedSubtotal}</div>
                  </div>
                  <div className="flex justify-between items-center py-1 border-b border-cyan-200">
                    <div className="text-xs text-gray-200">Discount:</div>
                    <div className="text-xs font-semibold text-red-400">- {formattedDiscount}</div>
                  </div>
                  <div className="flex justify-between items-center py-1 border-b border-cyan-200">
                    <div className="text-xs text-gray-200">Subtotal After Discount:</div>
                    <div className="text-xs font-semibold text-white">{formattedSubtotalAfterDiscount}</div>
                  </div>
                  <div className="flex justify-between items-center py-1 border-b border-cyan-200">
                    <div className="text-xs text-gray-200">Tax:</div>
                    <div className="text-xs font-semibold text-white">{formattedTax}</div>
                  </div>
                </div>
                <div className="flex justify-between items-center py-1 font-semibold text-lg text-gray-100 border-cyan-200 ">
                  <div className="text-xs:text-base">Grand Total:</div>
                  <div className="text-xs:text-base">{formattedGrandTotal}</div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
    {isModalOpen && (
        <DeleteConfirmationModal
          title="Cancel/Delete Quotation"
          message={`This will navigate to the delete page for quotation: ${itemToDelete?.name || itemToDelete?.reference}.`}
          actionLabel="Proceed to Delete"
          onConfirm={handleConfirmDelete}
          onCancel={handleCancelDelete}
          itemName={itemToDelete?.name || itemToDelete?.reference}
        />
      )}
    </Layout>
  );
};

export default DeleteQuotation;
